module.exports = __webpack_public_path__ + "img/running.5c62c43d.svg";